import { useEffect } from 'react';
import { useAuthStore } from '../store/authStore';

export const useAuth = () => {
  const { user, isAuthenticated, isLoading, error, login, logout, clearError } = useAuthStore();

  useEffect(() => {
    // Check token validity on mount
    const token = localStorage.getItem('access_token');
    if (token && !user) {
      // Fetch user profile
      useAuthStore.getState().checkAuth();
    }
  }, []);

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    clearError,
    isAdmin: user?.role === 'admin',
    isSeller: user?.role === 'seller' || user?.role === 'admin',
    isInstaller: user?.role === 'installer',
  };
};